<template>
    <div class="app-container">
        <el-card shadow="never">
            <!--查询框-->
            <el-form class="filterForm myFilterForm" :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch">
                <el-form-item prop="jobName">
                    <el-input
                            v-model="queryParams.jobName"
                            placeholder="职位名称"
                            clearable
                            size="mini"
                            @keyup.enter.native="handleQuery"
                            maxlength="20"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="enterpriseName">
                    <el-input
                            v-model="queryParams.enterpriseName"
                            placeholder="公司名称"
                            clearable
                            size="mini"
                            @keyup.enter.native="handleQuery"
                            maxlength="20"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="cyan" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                    <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
                </el-form-item>
            </el-form>
            <!--发布职位按钮-->
            <el-row :gutter="10" class="mb8">
                <el-col :span="1.5">
                    <el-button type="danger" :disabled="ids.length == 0" icon="el-icon-delete" size="mini"
                               @click="batchDelete" v-has-permi="['enterprise:collect:batchDel']">批量删除
                    </el-button>
                </el-col>
                <right-toolbar :showSearch.sync="showSearch" @queryTable="getPage"></right-toolbar>
            </el-row>
            <!--列表-->
            <el-table class="dataTable" stripe v-loading="loading" :data="collectionList" border
                      @selection-change="handleSelectionChange" :row-key="(row)=> {return row.id}">
                <el-table-column type="selection" width="55" align="center" :reserve-selection="true"/>
                <el-table-column label="职位名称" align="center" min-width="120" prop="jobPositionBaseInfo.positionName"
                                 show-overflow-tooltip/>
                <el-table-column label="薪资范围" align="center" min-width="150" :formatter="rangeFormatter"/>
                <el-table-column label="公司名称" align="center" min-width="150" prop="jobPositionBaseInfo.enterpriseName"
                                 show-overflow-tooltip/>
                <el-table-column label="工作地点" align="center" min-width="180"
                                 prop="jobPositionBaseInfo.enterpriseAddress.detailedAddress" show-overflow-tooltip/>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text"
                                   @click="handleDetail(scope.row)">查看</el-button>
                        <el-button size="mini" type="text"
                                   @click="handleDelivery(scope.row)"
                                   v-has-permi="['resume:delivery:add']">投递简历</el-button>
                        <el-button size="mini" type="text"
                                   @click="handleRemoveItem(scope.row)"
                                   v-has-permi="['enterprise:collect:delete']">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <pagination
                    :total="total"
                    :page.sync="queryParams.pageNumber"
                    :limit.sync="queryParams.pageSize"
                    @pagination="getPage"
            />
        </el-card>
        <!-- 投递简历 -->
        <el-dialog title="投递简历" :visible.sync="submitResumeDialog" width="460px" heigth="240px"
                   :before-close="closeSubmitResumeDialog">
            <el-form label-width="80px" ref="submitResumeForm" :model="form">
                <el-form-item label="简历" prop="resumeId" verify>
                    <el-select v-model="form.resumeId" clearable placeholder="请选择">
                        <el-option
                                v-for="item in resumeList"
                                :key="item.id"
                                :label="item.resumeName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitResume('submitResumeForm')">确 认</el-button>
                <el-button @click="closeSubmitResumeDialog">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {batchDeleteJobCollection, deleteJobCollection, getJobCollectionPageList} from '@/api/jobCollection';
    import {saveResumeDeliveryRecord} from '@/api/resumeDeliveryRecord'
    import {getBaseInfoListByCreatorId} from '@/api/resume'
    import {queryData} from '@/api/job';

    const YEAR_WAGES = 0;       // 年薪
    const MONTHLY_WAGES = 1;    // 月薪
    const DAILY_WAGES = 2;      // 日薪
    const HOURLY_WAGES = 3;     // 时薪
    const FACE_TO_FACE_WAGES = 4;     // 面议
    export default {
        name: 'Collection',
        data() {
            return {
                loading: false, //遮罩层
                ids: [], //选中数组
                multipleData: [], //多选数据
                single: true, //非单个禁用
                showSearch: true, //显示搜索条件
                total: 0, //分页总条数
                collectionList: [], //收藏分页列表
                // 查询参数
                queryParams: {
                    pageNumber: 1,
                    pageSize: 10,
                    jobName: undefined,
                    enterpriseName: undefined,
                },

                submitResumeDialog: false, //简历弹框
                resumeList: [], //简历列表
                editItem: {}, //当前编辑项
                form: {
                    resumeId: ''
                },
            }
        },
        created() {
            this.getPage();
        },
        methods: {
            /** 批量删除*/
            batchDelete() {
                this.$confirm(`确认删除选中的${this.ids.length}个收藏职位？`, '批量删除收藏职位', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    batchDeleteJobCollection({
                        ids: this.ids.join(",")
                    }).then((res) => {
                        this.msgSuccess("删除成功！");
                        this.getPage();
                        this.ids = [];
                        this.multipleData = [];
                    });
                }).catch(() => {
                });
            },
            /** 单项删除*/
            handleRemoveItem(row) {
                this.$confirm('确认删除收藏职位？', '删除收藏职位', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteJobCollection(row.id).then((res) => {
                        this.msgSuccess("删除成功！");
                        this.getPage();
                    });
                }).catch(() => {
                });
            },
            /** 搜索*/
            handleQuery() {
                this.queryParams.pageNumber = 1;
                this.getPage();
            },
            /** 重置*/
            resetQuery() {
                this.resetForm("queryForm");
                this.handleQuery();
            },
            /** 获取分页数据*/
            getPage() {
                this.loading = true;
                getJobCollectionPageList(this.queryParams).then(response => {
                    this.collectionList = response.data.content;
                    this.total = parseInt(response.data.totalElements);
                    this.loading = false;
                });
            },
            /**多选框选中数据 */
            handleSelectionChange(selection) {
                this.multipleData = selection;
                this.ids = selection.map(item => item.id);
                this.single = selection.length != 1;
            },
            rangeFormatter(row, column) {
                let msg = '';
                let min = row.jobPositionBaseInfo.minimumWage;
                let max = row.jobPositionBaseInfo.maximumWage;
                switch (row.jobPositionBaseInfo.payMethod) {
                    case YEAR_WAGES:
                        msg = min / 10000 + '~' + max / 10000 + 'W•年';
                        break;
                    case MONTHLY_WAGES:
                        msg = min / 1000 + '~' + max / 1000 + 'K•月';
                        break;
                    case DAILY_WAGES:
                        msg = min + '~' + max + '•日';
                        break;
                    case HOURLY_WAGES:
                        msg = min + '~' + max + '•时';
                        break;
                    case FACE_TO_FACE_WAGES:
                        msg = "面议";
                        break;
                }
                return msg;
            },
            /** 打开职位详情*/
            handleDetail(row) {
                queryData({id: row.jobPositionBaseInfo.id}).then((res) => {
                    if (res.data) {
                        let href = ''
                        if (process.env.NODE_ENV == "development") {
                            href = window.location.origin + "/frontend#/jobDetails/" + row.jobPositionBaseInfo.id;
                        } else {
                            href = window.location.origin + "/#/jobDetails/" + row.jobPositionBaseInfo.id;
                        }
                        if(navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)){
                            location.href = href
                        }else {
                            window.open(href)
                        }
                    } else {
                        this.$message('职位已删除');
                    }
                })
            },
            /** 简历投递*/
            handleDelivery(row) {
                queryData({id: row.jobPositionBaseInfo.id}).then((res) => {
                    if (res.data) {
                        this.getResumeList();
                        this.editItem = JSON.parse(JSON.stringify(row));
                        this.submitResumeDialog = true;
                    } else {
                        this.$message('职位已删除');
                    }
                })
            },
            /** 取消投递简历*/
            closeSubmitResumeDialog() {
                this.resetForm("submitResumeForm");
                this.submitResumeDialog = false;
            },
            /** 投递简历*/
            submitResume(form) {
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        let resumeId = this.form.resumeId;
                        let jobPositionId = this.editItem.jobPositionBaseInfo.id;
                        let enterpriseId = this.editItem.jobPositionBaseInfo.enterpriseId;

                        if (!jobPositionId || !enterpriseId) {
                            this.msgError("投递失败，数据有误！")
                            return false
                        }
                        saveResumeDeliveryRecord({
                            resumeId: resumeId,
                            jobPositionId: jobPositionId,
                            positionName: this.editItem.jobPositionBaseInfo.positionName,
                            enterpriseId: enterpriseId,
                            enterpriseName: this.editItem.jobPositionBaseInfo.enterpriseName
                        }).then((res) => {
                            this.msgSuccess("投递成功");
                            this.closeSubmitResumeDialog();
                        });
                    }
                });
            },
            getResumeList() {
                if (this.resumeList.length == 0) {
                    getBaseInfoListByCreatorId().then((res) => {
                        this.resumeList = res.data;
                    });
                }
            }
        }
    }
</script>
<style>
</style>
